import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  ButtonAdd,
  ContainerButton2,
  Form,
  Input,
  SelectInput,
  TextTitle,
  Title,
} from "../../../../styles/global";
import Panel from "../../../../components/Panel";
import { Button, Container } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faX } from "@fortawesome/free-solid-svg-icons";
import Grid from "@mui/material/Unstable_Grid2";
import { Link, useParams } from "react-router-dom";
import { FormHandles } from "@unform/core";
import { SaveWithProgress } from "../../../../components/SaveCircularIntegration";
import { formatarReais, formatarRealparaDecimal } from "../../../../utils/formatDados";
import organizeDataNumeroProcesso from "../../../../utils/organizeDataNumeroProcesso";
import useProcesso from "../../../../actions/cruds/Processos/useProcesso";
import Radio from "../../../../components/InputRadio";
import useProjeto from "../../../../actions/cruds/useProjeto";
import SecondaryTable from "../../../../components/SecondaryTable";
import { GridColDef, GridRenderEditCellParams, GridValueFormatterParams, useGridApiRef } from "@mui/x-data-grid";
import BasicDialog from "../../../../components/Dialog";
import useDotacao from "../../../../actions/cruds/Orcamentario/useDotacao";
import { useToast } from "../../../../hooks/toast";
import InputNumberFormat from "../../../../components/InputNumberFormat";

const OrcamentarioDotacaoEdit: React.FC = () => {
  const { dotacaoId } = useParams();
  const { dotacao, getDotacao, updateDotacao } = useDotacao();
  const { processos, getProcessos, processo, getProcesso } = useProcesso();
  const { projeto, getProjetoId } = useProjeto();
  const { addToast } = useToast();

  const [salvando, setSalvando] = useState<boolean>(false);
  const [linhasProjeto, setLinhasProjeto] = useState<Array<Object>>([]);
  const [valorLinhas, setValorLinhas] = useState<Array<Object>>([]);
  const [openDialog, setOpenDialog] = useState(false);


  useEffect(() => {
    getDotacao(dotacaoId);
    getProcessos([{ label: 'ativo', value: true }]);
  }, [])

  useEffect(() => {
    if (dotacao?.id) {
      formRef.current?.setFieldValue("data_solicitacao", dotacao?.data_solicitacao);
      formRef.current?.setFieldValue("law_process_id", { value: dotacao?.law_process?.id, label: `${dotacao?.law_process?.codigo} - (SIGAD - ${dotacao?.law_process?.numero})` });
      formRef.current?.setFieldValue("assunto", dotacao?.assunto);
      formRef.current?.setFieldValue("tipo_atividade", tipoAtividadeOptions.find((atividade) => atividade.value == dotacao?.tipo_atividade));
      // formRef.current?.setFieldValue("rateio", `${dotacao.rateio}`);
    };
  }, [dotacao])

  useEffect(() => {
    if (processo?.id) {
      formRef.current?.setFieldValue("rateio", `${processo?.project?.rateio}`);
      setLinhasProjeto(organizeDataLinhas(dotacao?.allocation_budgets))
      setValorLinhas(organizeDataLinhas(dotacao?.allocation_budgets))
    };

  }, [processo]);

  // useEffect(() => {
  //   if (projeto?.id) {
  //     setLinhasProjeto(organizeDataLinhas(projeto?.project_lines))
  //   }
  // }, [projeto]);


  const organizeDataLinhas = (data) => {
    if (typeof data === 'object') {
      if (Object.keys(data).length > 0) {
        data = data.map(d => ({
          id: d?.id,
          project_line_id: d?.project_line?.id,
          codigo: `${d?.project_line.expense_type?.codigo}.${d?.project_line?.organization?.codigo.padStart(2, '0')}.${d?.project_line?.management_contract?.codigo.padStart(2, '0')}.${d?.project_line?.comittee?.codigo.padStart(2, '0')}.${d?.project_line?.unit?.codigo.padStart(2, '0')}.${d?.project_line?.pap_finality?.codigo.padStart(2, '0')}.${d.project_line.pap_program.codigo.padStart(2, '0')}.${d.project_line.pap_action.codigo.padStart(2, '0')}.${d.project_line.poa_sub_action.codigo.padStart(2, '0')}.${processo?.project?.id.toString().padStart(2, '0')}.${d?.project_line?.description?.codigo.padStart(3, '0')}`,
          pap: `${d?.project_line?.pap_finality?.codigo}.${d?.project_line?.pap_program?.codigo}.${d?.project_line?.pap_action?.codigo}`,
          valor: formatarReais(d?.valor),
          val: d?.valor,
        }));
        return data;
      }
    }
    return [];
  };

  const tipoAtividadeOptions = [
    { value: "Meio", label: "Meio" },
    { value: "Fim", label: "Fim" },
  ];

  const optionsBoolean = [
    { id: 'true', value: true, label: "Sim" },
    { id: 'false', value: false, label: "Não" },
  ];

  const apiRef = useGridApiRef();
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: object) => {
      try {
        setSalvando(true)

        const rowsData = Array.from(apiRef.current.getRowModels(), ([, value]) => (value));
        if (rowsData.length > 0) {
          const rubricaSemValor = rowsData.every(row => row.valor);
          if (!rubricaSemValor) {
            addToast({
              type: 'error',
              title: 'Erro',
              description: "Todas as linhas da Rubrica orçamentária devem conter valor.",
            });
            return;
          }

          data["allocation_budgets_attributes"] = rowsData.map(d => ({
            id: d?.id,
            project_line_id: d.project_line_id,
            valor: typeof(d.valor) == 'string' ? formatarRealparaDecimal(d.valor) : d.valor,
          }));
        }

        console.log("data", data);
        await updateDotacao(dotacaoId, data);
      } catch (err) {

      } finally {
        setSalvando(false);
      }
    }, []
  );

  const dataTitleLinhas: GridColDef[] = [
    { field: "codigo", headerName: "Código do projeto", minWidth: 220, flex: 3 },
    { field: "pap", headerName: "Código do PAP", minWidth: 115, flex: 1 },
    {
      field: "valor",
      headerName: "Valor da Dotação",
      editable: true,
      flex: 2,
      valueFormatter: (params: GridValueFormatterParams<number>) => {
        if (params.value == null) {
          return "R$ 0,00";
        }
        return params.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      },
      renderEditCell: (params: GridRenderEditCellParams) => (
        <InputNumberFormat {...params} />
      ),
    },
  ];

  const handleUpdateLinha = (updatedRow: Object) => {
    const objUpdatedRow = { id: updatedRow?.id, val: updatedRow?.valor };
    const updatedValueLinhas = [...valorLinhas.filter((linha) => linha.id !== updatedRow?.id), objUpdatedRow];
    setValorLinhas(updatedValueLinhas)

    return updatedRow
  };

  return (
    <Container>
      <Form id="formDotacao" ref={formRef} onSubmit={handleSubmit}>
        <Title color="#333">
          <span>Edição de Dotação</span>
        </Title>

        <Panel titulo="Identificação">
          <Grid container spacing={6}>
            <Grid xs={6}>
              <TextTitle>Data da solicitação:</TextTitle>
              <Input type="date" name="data_solicitacao" required />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Número do processo:</TextTitle>
              <SelectInput
                name="law_process_id"
                placeholder="Selecione..."
                options={organizeDataNumeroProcesso(processos.data, "id", "codigo", "numero")}
                onInputChange={(e) => {
                  getProcessos([{ label: 'numero', value: e }, { label: 'ativo', value: true }]);
                }}
                onChange={(e) => getProcesso(e.value)}
                isDisabled
              />
            </Grid>
            <Grid xs={12}>
              <TextTitle>Assunto:</TextTitle>
              <Input type="text" name="assunto" required />
            </Grid>
            <Grid xs={6}>
              <TextTitle>Tipo de atividade:</TextTitle>
              <SelectInput
                name="tipo_atividade"
                placeholder="Selecione..."
                options={tipoAtividadeOptions}
                required
              />
            </Grid>
            <Grid xs={6}>
              <TextTitle>O projeto é um rateio?</TextTitle>
              <Radio
                name="rateio"
                options={optionsBoolean}
                required
                disabled
              />
            </Grid>
          </Grid>
        </Panel>

        <Panel titulo="Linha">
          <Grid container spacing={6}>
            <Grid xs={12}>
              {dotacao?.allocation_budgets?.length > 0 && processo?.id && (
                <>
                  <SecondaryTable
                    apiRef={apiRef}
                    columsData={dataTitleLinhas}
                    rowsData={linhasProjeto}
                    processRowUpdate={(updatedRow: Object) => handleUpdateLinha(updatedRow)}
                    onProcessRowUpdateError={(error) => console.log(error)}
                  />
                  <Grid xs={6}>
                    <TextTitle>Total: {formatarReais(valorLinhas?.reduce(function (acc, obj) { return acc + parseFloat(obj?.val); }, 0))}</TextTitle>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Panel>
      </Form>

      <ContainerButton2>
        <Link to="/orcamentario/dotacao">
          <button className="button_return">
            <FontAwesomeIcon icon={faX} size="1x" /> Cancelar
          </button>
        </Link>
        <SaveWithProgress disabled={salvando} form={"formDotacao"}></SaveWithProgress>
      </ContainerButton2>
    </Container >
  );
};

export default OrcamentarioDotacaoEdit;
